

// Info item definition
class InfoItemVM {
  id: string;
  type: string;
  title: string;
  value: string | null;
  file: any | null;
  children: InfoItemVM[];

  constructor(data?: Partial<InfoItemVM>) {
    this.id = data?.id || ''
    this.type = data?.type || ''
    this.title = data?.title || ''
    this.value = data?.value || null
    this.file = data?.file || null
    this.children = data?.children ? data.children.map(child => (child)) : []
  }
}

// Info entry definition
class InfoEntryVM {
  uuid: string;
  items: InfoItemVM[];

  constructor(data?: Partial<InfoEntryVM>) {
    this.uuid = data?.uuid || ''
    this.items = data?.items ? data.items.map(item => (item)) : []
  }
}

// Info definition
class InfoVM {
  [key: string]: InfoEntryVM;

  constructor(data?: Record<string, InfoEntryVM>) {
    if (data) {
      Object.keys(data).forEach(key => {
        this[key] = data[key] instanceof InfoEntryVM ? data[key] : new InfoEntryVM(data[key])
      })
    }
  }
}
export {InfoVM, InfoEntryVM, InfoItemVM}
